/**
* Featured Benefits JS
* -----------------------------------------------------------------------------
*
* All the JS for the Featured Benefits component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'featured-benefits',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.featured-benefits__benefit' ).on( 'mouseenter', function() {
        const benefitKey = $( this ).attr( 'data-benefit' );
        const benefitImage = $( this ).closest( '.featured-benefits' ).find( '.featured-benefits__benefit-image[data-benefit="' + benefitKey + '"]' );
        const backgroundImage = $( this ).closest( '.featured-benefits' ).find( '.featured-benefits__background-image-blur' );
        $( benefitImage ).addClass( 'is-hovered' );
        $( backgroundImage ).addClass( 'is-hovered' );
      } ).on( 'mouseleave', function() {
        const benefitKey = $( this ).attr( 'data-benefit' );
        const benefitImage = $( this ).closest( '.featured-benefits' ).find( '.featured-benefits__benefit-image[data-benefit="' + benefitKey + '"]' );
        const backgroundImage = $( this ).closest( '.featured-benefits' ).find( '.featured-benefits__background-image-blur' );
        $( benefitImage ).removeClass( 'is-hovered' );
        $( backgroundImage ).removeClass( 'is-hovered' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'featured-benefits', COMPONENT );
} )( app );
